import React, { ReactElement } from 'react';
import { Typography } from '@material-ui/core';

import { InputField } from 'components';

import {
  InputContainer,
  TitleContainer,
  StyledErrorMessage,
  StyledErrorMessageContainer,
} from './InputFieldWithLabel.styles';
import { LabelWithUIGuidelines } from 'component-library/atoms/LabelWithUIGuidelines';

type Props = {
  label: string;
  name: string;
  placeholder: string;
  addons?: ReactElement<any, any>;
  type?: string;
  required?: boolean;
  textCase?: 'upper' | 'lower' | 'title' | 'sentence';
};

const InputFieldWithLabel = ({
  label,
  name,
  placeholder,
  addons,
  type = 'text',
  textCase,
  required = false,
}: Props): JSX.Element => (
  <InputContainer>
    <TitleContainer>
      <LabelWithUIGuidelines label={label} required={required} />
      {addons}
    </TitleContainer>
    <InputField
      type={type}
      name={name}
      label={placeholder}
      variant="outlined"
    />
    <StyledErrorMessageContainer>
      <StyledErrorMessage
        name={name}
        component={(props) => <Typography {...props} variant="caption" />}
      />
    </StyledErrorMessageContainer>
  </InputContainer>
);

export default InputFieldWithLabel;
